import React from "react";
import styled from "styled-components";

export default styled.div`
    float: left;
    width: 50%;
    margin-bottom: 50px;
    padding-right: 25px;

   h2 {
    color: #5562C0;
    font-size: 26px;
    font-weight: 700;
   }
   p {
       font-size: 18px;
       line-height: 24px;
       color: #515151;

       &.old {
        color: #bdbdbd;

        }
   }
   ol {
        padding-left: 20px;
        font-size: 18px;
        color: #515151;
    
        li {
            padding: 6px 0;
        }

        a {
            color: #4E99D6;
            cursor: pointer;
            text-decoration: underline;
        }
   }
   small {
        color: #515151;
        a {
            color: #4E99D6;
            cursor: pointer;
            text-decoration: underline;
        }
   }
`;